import { ErrorHandler, Injectable } from '@angular/core'
import { SentryContextService } from './sentry-context.service'

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor(private sentryContext: SentryContextService) {}

  handleError(error: any) {
    this.sentryContext.reportError(error)
    // We must throw or log the error in the custom handler. Without it, uncaught errors will be silenced.
    throw error
  }
}
